import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useFlagStore } from '@/stores/flag';

/**
 * `beforeEnter` guard for `<overview>.report` routes whose surface has no legacy report page.
 * Flag on → the unified shell self-renders the report layout; flag off → the report route has
 * nothing to render, so redirect to the plain overview route (`.report` suffix stripped).
 * Surfaces with a real legacy report (Facebook, X, Instagram overview) don't attach this guard:
 * their flag-off side still renders the legacy report.
 */
export async function legacyReportRedirectGuard(
  to: RouteLocationNormalized,
): Promise<NavigationGuardReturn> {
  const flagStore = useFlagStore();

  await flagStore.waitForUserFlags;
  if (flagStore.ready && flagStore.flags.overviewPagesGds) return true;

  const overviewRouteName = String(to.name).replace(/\.report$/, '');
  return { name: overviewRouteName, params: to.params, query: to.query };
}
